export const BuildingIcon = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 22.75H2C1.59 22.75 1.25 22.41 1.25 22C1.25 21.59 1.59 21.25 2 21.25H22C22.41 21.25 22.75 21.59 22.75 22C22.75 22.41 22.41 22.75 22 22.75Z"
      fill="currentColor"
    />
    <path
      d="M21 22.75H3C2.59 22.75 2.25 22.41 2.25 22V6C2.25 2.98 3.98 1.25 7 1.25H17C20.02 1.25 21.75 2.98 21.75 6V22C21.75 22.41 21.41 22.75 21 22.75ZM3.75 21.25H20.25V6C20.25 3.78 19.22 2.75 17 2.75H7C4.78 2.75 3.75 3.78 3.75 6V21.25Z"
      fill="currentColor"
    />
    <path
      d="M10 17.25H7C6.59 17.25 6.25 16.91 6.25 16.5C6.25 16.09 6.59 15.75 7 15.75H10C10.41 15.75 10.75 16.09 10.75 16.5C10.75 16.91 10.41 17.25 10 17.25Z"
      fill="#5CA9FB"
    />
    <path
      d="M17 17.25H14C13.59 17.25 13.25 16.91 13.25 16.5C13.25 16.09 13.59 15.75 14 15.75H17C17.41 15.75 17.75 16.09 17.75 16.5C17.75 16.91 17.41 17.25 17 17.25Z"
      fill="#5CA9FB"
    />
    <path
      d="M10 12.75H7C6.59 12.75 6.25 12.41 6.25 12C6.25 11.59 6.59 11.25 7 11.25H10C10.41 11.25 10.75 11.59 10.75 12C10.75 12.41 10.41 12.75 10 12.75Z"
      fill="#5CA9FB"
    />
    <path
      d="M17 12.75H14C13.59 12.75 13.25 12.41 13.25 12C13.25 11.59 13.59 11.25 14 11.25H17C17.41 11.25 17.75 11.59 17.75 12C17.75 12.41 17.41 12.75 17 12.75Z"
      fill="#5CA9FB"
    />
    <path
      d="M10 8.25H7C6.59 8.25 6.25 7.91 6.25 7.5C6.25 7.09 6.59 6.75 7 6.75H10C10.41 6.75 10.75 7.09 10.75 7.5C10.75 7.91 10.41 8.25 10 8.25Z"
      fill="#5CA9FB"
    />
    <path
      d="M17 8.25H14C13.59 8.25 13.25 7.91 13.25 7.5C13.25 7.09 13.59 6.75 14 6.75H17C17.41 6.75 17.75 7.09 17.75 7.5C17.75 7.91 17.41 8.25 17 8.25Z"
      fill="#5CA9FB"
    />
  </svg>
);
export const VideoIcon = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.88 20.8606H6.81C3.26 20.8606 2 18.3706 2 16.0506V7.95062C2 4.49062 3.35 3.14062 6.81 3.14062H12.88C16.34 3.14062 17.69 4.49062 17.69 7.95062V16.0506C17.69 19.5106 16.34 20.8606 12.88 20.8606ZM6.81 4.66062C4.2 4.66062 3.52 5.34062 3.52 7.95062V16.0506C3.52 17.2806 3.95 19.3406 6.81 19.3406H12.88C15.49 19.3406 16.17 18.6606 16.17 16.0506V7.95062C16.17 5.34062 15.49 4.66062 12.88 4.66062H6.81Z"
      fill="#12D940"
    />
    <path
      d="M20.7797 18.1105C20.3497 18.1105 19.7997 17.9705 19.1697 17.5305L16.4997 15.6605C16.2997 15.5205 16.1797 15.2905 16.1797 15.0405V8.96048C16.1797 8.71048 16.2997 8.48048 16.4997 8.34048L19.1697 6.47048C20.3597 5.64048 21.2297 5.88048 21.6397 6.09048C22.0497 6.31048 22.7497 6.88048 22.7497 8.33048V15.6605C22.7497 17.1105 22.0497 17.6905 21.6397 17.9005C21.4497 18.0105 21.1497 18.1105 20.7797 18.1105ZM17.6897 14.6405L20.0397 16.2805C20.4897 16.5905 20.8097 16.6205 20.9397 16.5505C21.0797 16.4805 21.2297 16.2005 21.2297 15.6605V8.34048C21.2297 7.79048 21.0697 7.52048 20.9397 7.45048C20.8097 7.38048 20.4897 7.41048 20.0397 7.72048L17.6897 9.36048V14.6405Z"
      fill="#12D940"
    />
    <path
      d="M11.5 11.75C10.26 11.75 9.25 10.74 9.25 9.5C9.25 8.26 10.26 7.25 11.5 7.25C12.74 7.25 13.75 8.26 13.75 9.5C13.75 10.74 12.74 11.75 11.5 11.75ZM11.5 8.75C11.09 8.75 10.75 9.09 10.75 9.5C10.75 9.91 11.09 10.25 11.5 10.25C11.91 10.25 12.25 9.91 12.25 9.5C12.25 9.09 11.91 8.75 11.5 8.75Z"
      fill="#12D940"
    />
  </svg>
);
export const LcUserIcon = () => (
  <svg
    width={64}
    height={64}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.4249 30.9866C32.3449 30.9866 32.2915 30.9866 32.2115 30.9866C32.0782 30.9599 31.8915 30.9599 31.7315 30.9866C23.9982 30.7466 18.1582 24.6666 18.1582 17.1733C18.1582 9.54659 24.3715 3.33325 31.9982 3.33325C39.6249 3.33325 45.8382 9.54659 45.8382 17.1733C45.8115 24.6666 39.9449 30.7466 32.5049 30.9866C32.4782 30.9866 32.4515 30.9866 32.4249 30.9866ZM31.9982 7.33325C26.5849 7.33325 22.1582 11.7599 22.1582 17.1733C22.1582 22.5066 26.3182 26.7999 31.6249 26.9866C31.7582 26.9599 32.1315 26.9599 32.4782 26.9866C37.7049 26.7466 41.8115 22.4533 41.8382 17.1733C41.8382 11.7599 37.4115 7.33325 31.9982 7.33325Z"
      fill="currentColor"
    />
    <path
      d="M32.4523 60.1334C27.2256 60.1334 21.9723 58.8001 17.999 56.1334C14.2923 53.6801 12.2656 50.3201 12.2656 46.6667C12.2656 43.0134 14.2923 39.6267 17.999 37.1467C25.999 31.8401 38.959 31.8401 46.9056 37.1467C50.5856 39.6001 52.639 42.9601 52.639 46.6134C52.639 50.2667 50.6123 53.6534 46.9056 56.1334C42.9056 58.8001 37.679 60.1334 32.4523 60.1334ZM20.2123 40.5067C17.6523 42.2134 16.2656 44.4001 16.2656 46.6934C16.2656 48.9601 17.679 51.1467 20.2123 52.8267C26.8523 57.2801 38.0523 57.2801 44.6923 52.8267C47.2523 51.1201 48.639 48.9334 48.639 46.6401C48.639 44.3734 47.2256 42.1867 44.6923 40.5067C38.0523 36.0801 26.8523 36.0801 20.2123 40.5067Z"
      fill="currentColor"
    />
  </svg>
);
export const UserIcon = () => (
  <svg
    width={64}
    height={64}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.0003 33.9999C23.547 33.9999 16.667 27.1199 16.667 18.6666C16.667 10.2133 23.547 3.33325 32.0003 3.33325C40.4537 3.33325 47.3337 10.2133 47.3337 18.6666C47.3337 27.1199 40.4537 33.9999 32.0003 33.9999ZM32.0003 7.33325C25.7603 7.33325 20.667 12.4266 20.667 18.6666C20.667 24.9066 25.7603 29.9999 32.0003 29.9999C38.2403 29.9999 43.3337 24.9066 43.3337 18.6666C43.3337 12.4266 38.2403 7.33325 32.0003 7.33325Z"
      fill="currentColor"
    />
    <path
      d="M54.9071 60.6667C53.8137 60.6667 52.9071 59.76 52.9071 58.6667C52.9071 49.4667 43.5204 42 32.0004 42C20.4804 42 11.0937 49.4667 11.0937 58.6667C11.0937 59.76 10.1871 60.6667 9.09375 60.6667C8.00042 60.6667 7.09375 59.76 7.09375 58.6667C7.09375 47.28 18.2671 38 32.0004 38C45.7337 38 56.9071 47.28 56.9071 58.6667C56.9071 59.76 56.0004 60.6667 54.9071 60.6667Z"
      fill="currentColor"
    />
  </svg>
);
export const BookIcon = () => (
  <svg
    width={64}
    height={64}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.33301 49.9999C8.23967 49.9999 7.33301 49.0933 7.33301 47.9999V18.6666C7.33301 6.90659 10.9063 3.33325 22.6663 3.33325H41.333C53.093 3.33325 56.6663 6.90659 56.6663 18.6666V45.3333C56.6663 45.7599 56.6663 46.1599 56.6397 46.5866C56.5597 47.6799 55.573 48.5333 54.5063 48.4533C53.413 48.3733 52.5597 47.4133 52.6397 46.3199C52.6663 45.9999 52.6663 45.6533 52.6663 45.3333V18.6666C52.6663 9.14659 50.8797 7.33325 41.333 7.33325H22.6663C13.1197 7.33325 11.333 9.14659 11.333 18.6666V47.9999C11.333 49.0933 10.4263 49.9999 9.33301 49.9999Z"
      fill="currentColor"
    />
    <path
      d="M45.333 60.6667H18.6663C12.4263 60.6667 7.33301 55.5733 7.33301 49.3333V47.6C7.33301 42.2933 11.653 38 16.933 38H54.6663C55.7597 38 56.6663 38.9067 56.6663 40V49.3333C56.6663 55.5733 51.573 60.6667 45.333 60.6667ZM16.933 42C13.8397 42 11.333 44.5067 11.333 47.6V49.3333C11.333 53.3867 14.613 56.6667 18.6663 56.6667H45.333C49.3863 56.6667 52.6663 53.3867 52.6663 49.3333V42H16.933Z"
      fill="currentColor"
    />
    <path
      d="M42.6663 20.6667H21.333C20.2397 20.6667 19.333 19.7601 19.333 18.6667C19.333 17.5734 20.2397 16.6667 21.333 16.6667H42.6663C43.7597 16.6667 44.6663 17.5734 44.6663 18.6667C44.6663 19.7601 43.7597 20.6667 42.6663 20.6667Z"
      fill="currentColor"
    />
    <path
      d="M34.6663 30H21.333C20.2397 30 19.333 29.0933 19.333 28C19.333 26.9067 20.2397 26 21.333 26H34.6663C35.7597 26 36.6663 26.9067 36.6663 28C36.6663 29.0933 35.7597 30 34.6663 30Z"
      fill="currentColor"
    />
  </svg>
);
